<template>
  <a-layout class="ehf-layout-wrap">
    <hrm-side />
    <hrm-content :data-full-path="routeFullPath" />
  </a-layout>
</template>

<script>
  import HrmContent from './hrm-content'
  import HrmSide from './hrm-side'
  export default {
    name: 'HrmLayout',
    components: {
      HrmContent,
      HrmSide,
    },
    data() {
      return {
        routeFullPath: '',
      }
    },
    created() {
      this.routeFullPath = this.$route.fullPath || ''
    },
    watch: {
      $route(newVal) {
        this.routeFullPath = newVal.fullPath || ''
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ehf-layout-wrap {
    .ehf-layout {
      padding-left: 200px;
      transition: all 0.2s;
    }
  }
</style>
